import { IActionResponse, IActionResult, BaseClient, IPagedResult } from "../";
import { ApiParams } from "../../../assets/utils/lib";
import { GridStateDto, SearchStateDto, StateDto, } from "../../dto";

export class StateClient extends BaseClient {
    routes = ["system", "State"];

    async getStateAsync(id: string | undefined): Promise<StateDto> {
        const actions: string[] = ["GetState"];
        const params: ApiParams[] = [new ApiParams("id", id, true)];

        const result: StateDto = await this.getAsync<StateDto>(actions, params);
        return result;
    }

    async getStatesAsync(): Promise<StateDto[]> {
        const actions: string[] = ["GetAllStates"];

        const result: StateDto[] = await this.getAsync<StateDto[]>(actions);
        return result;
    }

    async searchStateAsync(payload: SearchStateDto | undefined): Promise<IPagedResult<GridStateDto>> {
        const actions: string[] = ["SearchStates"];
        const result: IPagedResult<GridStateDto> = await this.postAsync<SearchStateDto, GridStateDto, IPagedResult<GridStateDto>>(actions, payload);
        return result;
    }

    async saveStateAsync(payload: StateDto | undefined): Promise<IActionResult<StateDto>> {
        const actions: string[] = ["SaveState"];
        return await this.postAsync<StateDto>(actions, payload);
    }

    async deleteStateAsync(id?: string | undefined): Promise<IActionResponse> {
        const actions: string[] = ["DeleteState"];
        const params: ApiParams[] = [new ApiParams("id", id, true)];

        return await this.deleteAsync(actions, params);
    }
}
